import React, { useRef, useEffect } from 'react';

const ProjectSpotlight = () => {
  const spotlightRef = useRef(null);

  useEffect(() => {
    const spotlight = spotlightRef.current;
    const handleMouseMove = (e) => {
      const rect = spotlight.parentElement.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      spotlight.style.setProperty('--mouse-x', `${x}px`);
      spotlight.style.setProperty('--mouse-y', `${y}px`);
      spotlight.classList.add('active');
    };
    const handleMouseLeave = () => {
      spotlight.classList.remove('active');
    };
    spotlight.parentElement.addEventListener('mousemove', handleMouseMove);
    spotlight.parentElement.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      spotlight.parentElement.removeEventListener('mousemove', handleMouseMove);
      spotlight.parentElement.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <section className="mcd-spotlight-section">
      <div className="mcd-container-spotlight">
        <h2 className="mcd-section-title-spotlight">Our Policies</h2>
        <div className="mcd-spotlight-grid">
          <div className="mcd-spotlight-card">
            <h3>Quality Policy</h3>
            <p>
                <li>Maintain an organization system focused to clients' needs</li>
                <li>Build & cherish relationships with our client's and concentrating on making their business a success</li>
                <li>Provide continuous, high-value-added service</li>
            </p>
          </div>
          <div className="mcd-spotlight-card">
            <h3>Safety Policy</h3>
            <p>
                <li>Ensure a safe, pleasant work environment by promoting robust safety practices</li>
                <li>Take preventive action well in advance to avoid dangerous conditions and irregularities</li>
                <li>Develop individual personal responsibility regarding safety and operational excellence</li>
            </p>
          </div>
          <div className="mcd-spotlight-card">
            <h3>Drug and Alcohol Policy</h3>
            <p>
                <li>We recognize the critical need to combat the abuse of drugs and alcohol on board our vessels.</li>
                <li>The use, possession, distribution, or sale of any illicit drugs on board vessels is strictly prohibited. This includes any substance that impairs job performance or leads to abnormal or unsafe behavior.</li>
            </p>
          </div>
          
        </div>
      </div>
      <div ref={spotlightRef} className="mcd-spotlight-effect"></div>
    </section>
  );
};

export default ProjectSpotlight;